import "./Copyright.css";
export default function Copyright() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="copyright">
      <div className="copyright-inner">
        <p>© {currentYear} Yishak Hailu — All rights reserved.</p>
        <span>Built with React & GSAP · Ethiopia</span>
      </div>
    </div>
  );
}
